import type { NotificationTarget } from './notificationRouting';

/**
 * reco-comment-replies v2 — turn a resolved notification target into app state.
 *
 * Extracted so the routing decision is testable without mocking Capacitor's
 * push plugin, and so a reply push can be verified to land by SIGNALS rather
 * than by URL.
 *
 * A reply opens the conversation where it lives — on the card, in the feed —
 * reusing the chain `openSongCard` already performs: select the circle, land on
 * the card (Home pages forward until it is mounted), then open the sheet. v1
 * navigated to a dedicated route instead, which cost the user their circle and
 * their scroll position the moment they closed it.
 */
export interface NotificationSignals {
  setLandOnCircle: (id: number | null) => void;
  setLandOnReco: (id: number | null) => void;
  setOpenThreadForReco: (id: number | null) => void;
}

export function applyNotificationTarget(
  target: NotificationTarget,
  deps: { navigate: (route: string) => void; signals: NotificationSignals },
): void {
  const { navigate, signals } = deps;

  if (target.landOnCircleId != null) signals.setLandOnCircle(target.landOnCircleId);

  if (target.thread) {
    signals.setLandOnReco(target.thread.recommendationId);
    signals.setOpenThreadForReco(target.thread.recommendationId);
  }

  navigate(target.route);
}
